import Vue from 'vue';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

var script$1 = Vue.extend({
  name: "tmi-custom-svg",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    svgObject() {
      switch (this.icon) {
        case "tmi-facebook":
          return [{
            path: "M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z"
          }];
        case "tmi-github":
          return [{
            path: "M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z"
          }];
        case "tmi-gitlab":
          return [{
            path: "M21.94 13.11L20.89 9.89C20.89 9.86 20.88 9.83 20.87 9.8L18.76 3.32C18.65 3 18.33 2.75 17.96 2.75C17.6 2.75 17.28 3 17.17 3.33L15.17 9.5H8.84L6.83 3.33C6.72 3 6.4 2.75 6.04 2.75H6.04C5.67 2.75 5.35 3 5.24 3.33L3.13 9.82C3.13 9.82 3.13 9.83 3.13 9.83L2.06 13.11C1.9 13.61 2.07 14.15 2.5 14.45L11.72 21.16C11.89 21.28 12.11 21.28 12.28 21.15L21.5 14.45C21.93 14.15 22.1 13.61 21.94 13.11M8.15 10.45L10.72 18.36L4.55 10.45M13.28 18.37L15.75 10.78L15.85 10.45H19.46L13.87 17.61M17.97 3.94L19.78 9.5H16.16M14.86 10.45L13.07 15.96L12 19.24L9.14 10.45M6.03 3.94L7.84 9.5H4.23M3.05 13.69C2.96 13.62 2.92 13.5 2.96 13.4L3.75 10.97L9.57 18.42M20.95 13.69L14.44 18.42L14.46 18.39L20.25 10.97L21.04 13.4C21.08 13.5 21.04 13.62 20.95 13.69"
          }];
        case "tmi-instagram":
          return [{
            path: "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
          }];
        case "tmi-linkedin":
          return [{
            path: "M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z"
          }];
        case "tmi-signal":
          return [{
            path: "M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4A4,4 0 0,0 10,8A4,4 0 0,0 14,12A4,4 0 0,0 18,8A4,4 0 0,0 14,4Z"
          }];
        case "tmi-twitter":
          return [{
            path: "M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z"
          }];
        case "tmi-whatsapp":
          return [{
            path: "M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
          }];
        case "tmi-tiktok":
          return [{
            path: "M7.86796 18.3567C8.27134 18.5636 8.7206 18.6716 9.17664 18.6714C10.6957 18.6714 11.9358 17.4969 11.9918 16.0331L11.9974 2.96094H15.3529C15.3532 3.23859 15.3797 3.51562 15.4322 3.78854H12.9753V3.789H16.3312C16.3307 4.88303 16.7387 5.94008 17.4794 6.76385L17.4804 6.7649C18.2359 7.24467 19.1191 7.49976 20.0216 7.49893V8.22535C20.3375 8.2911 20.6641 8.32612 21 8.32612V11.5885C19.3247 11.5904 17.6914 11.0798 16.3312 10.1292V16.7577C16.3312 20.0677 13.5604 22.7609 10.1546 22.7609C9.30642 22.7611 8.46737 22.5911 7.68998 22.2614C6.91314 21.9319 6.21468 21.4502 5.63821 20.8463L5.63694 20.8454C4.04414 19.7584 3 17.9608 3 15.9301C3 12.6197 5.77084 9.926 9.17664 9.926C9.45517 9.92728 9.73323 9.947 10.009 9.98495V10.7572C10.0284 10.7569 10.0477 10.7562 10.067 10.7556C10.096 10.7546 10.1251 10.7536 10.1546 10.7536C10.433 10.7549 10.7111 10.7746 10.9869 10.8125V14.1425C10.7237 14.0622 10.4452 14.0155 10.1546 14.0155C9.40662 14.0163 8.68958 14.3056 8.16075 14.8197C7.63192 15.3338 7.33451 16.0308 7.33379 16.7577C7.33383 17.3319 7.52052 17.8914 7.86724 18.3563L7.86796 18.3567ZM4.38532 18.8998C4.67198 19.6258 5.09978 20.2843 5.63558 20.844C5.08887 20.2753 4.66671 19.614 4.38532 18.8998Z"
          }];
        case "tmi-medium":
          return [{
            path: "M6.76884 5.96094C10.5072 5.96094 13.5374 9.01236 13.5374 12.7762C13.5374 16.5401 10.5069 19.5913 6.76884 19.5913C3.03073 19.5913 0 16.5401 0 12.7762C0 9.01236 3.0305 5.96094 6.76884 5.96094ZM17.5782 6.36016C19.4474 6.36016 20.9626 9.23244 20.9626 12.7762H20.9628C20.9628 16.3191 19.4476 19.1923 17.5784 19.1923C15.7092 19.1923 14.194 16.3191 14.194 12.7762C14.194 9.23336 15.709 6.36016 17.5782 6.36016ZM22.8097 7.02844C23.4669 7.02844 24 9.60177 24 12.7762C24 15.9498 23.4672 18.524 22.8097 18.524C22.1522 18.524 21.6196 15.9505 21.6196 12.7762C21.6196 9.602 22.1524 7.02844 22.8097 7.02844Z"
          }];
        case "tmi-youtube":
          return [{
            path: "M10 15.9609L15.19 12.9609L10 9.96094V15.9609ZM21.56 8.13094C21.69 8.60094 21.78 9.23094 21.84 10.0309C21.91 10.8309 21.94 11.5209 21.94 12.1209L22 12.9609C22 15.1509 21.84 16.7609 21.56 17.7909C21.31 18.6909 20.73 19.2709 19.83 19.5209C19.36 19.6509 18.5 19.7409 17.18 19.8009C15.88 19.8709 14.69 19.9009 13.59 19.9009L12 19.9609C7.81 19.9609 5.2 19.8009 4.17 19.5209C3.27 19.2709 2.69 18.6909 2.44 17.7909C2.31 17.3209 2.22 16.6909 2.16 15.8909C2.09 15.0909 2.06 14.4009 2.06 13.8009L2 12.9609C2 10.7709 2.16 9.16094 2.44 8.13094C2.69 7.23094 3.27 6.65094 4.17 6.40094C4.64 6.27094 5.5 6.18094 6.82 6.12094C8.12 6.05094 9.31 6.02094 10.41 6.02094L12 5.96094C16.19 5.96094 18.8 6.12094 19.83 6.40094C20.73 6.65094 21.31 7.23094 21.56 8.13094Z"
          }];
        case "tmi-weight":
          return [{
            path: "M12 3a4 4 0 0 1 4 4c0 .73-.19 1.41-.54 2H18c.95 0 1.75.67 1.95 1.56C21.96 18.57 22 18.78 22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2c0-.22.04-.43 2.05-8.44C4.25 9.67 5.05 9 6 9h2.54A3.9 3.9 0 0 1 8 7a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2"
          }];
        case "tmi-weight-plus":
          return [{
            path: "M16.5 7a4.5 4.5 0 0 0-4.5 4.5c0 2.484 2.016 4.5 4.5 4.5s4.5-2.016 4.5-4.5S18.984 7 16.5 7m2.25 4.95h-1.8v1.8h-.9v-1.8h-1.8v-.9h1.8v-1.8h.9v1.8h1.8zM13.2 5.111c0 .568-.152 1.097-.432 1.556H14.8c.76 0-.695.254-1.65 1.139-1.517 1.194-1.713 2.77-1.68 4.189.03 1.2.53 2.303 1.375 3.05.252.223.977.955 2.193.955H3.6c-.884 0-1.6-.696-1.6-1.556 0-.17.032-.334 1.64-6.564.16-.692.8-1.213 1.56-1.213h2.032A2.96 2.96 0 0 1 6.8 5.11C6.8 3.393 8.233 2 10 2s3.2 1.393 3.2 3.111M10 3.556c-.884 0-1.6.696-1.6 1.555 0 .86.716 1.556 1.6 1.556s1.6-.697 1.6-1.556-.716-1.555-1.6-1.555"
          }];
        case "tmi-lightbulb-on":
          return [{
            path: "M20 11H23V13H20V11ZM1 11H4V13H1V11ZM13 1V4H11V1H13ZM4.92 3.5L7.05 5.64L5.63 7.05L3.5 4.93L4.92 3.5ZM16.95 5.63L19.07 3.5L20.5 4.93L18.37 7.05L16.95 5.63ZM12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 14.22 16.79 16.16 15 17.2V19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20H10C9.73478 20 9.48043 19.8946 9.29289 19.7071C9.10536 19.5196 9 19.2652 9 19V17.2C7.21 16.16 6 14.22 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6ZM14 21V22C14 22.2652 13.8946 22.5196 13.7071 22.7071C13.5196 22.8946 13.2652 23 13 23H11C10.7348 23 10.4804 22.8946 10.2929 22.7071C10.1054 22.5196 10 22.2652 10 22V21H14ZM11 18H13V15.87C14.73 15.43 16 13.86 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.86 9.27 15.43 11 15.87V18Z"
          }];
        case "tmi-account-time":
          return [{
            path: "M10.63 14.1a7 7 0 0 1 9.27-3.47a7 7 0 0 1 3.47 9.27A6.98 6.98 0 0 1 17 24c-2.7 0-5.17-1.56-6.33-4H1v-2c.06-1.14.84-2.07 2.34-2.82S6.72 14.04 9 14c.57 0 1.11.05 1.63.1M9 4c1.12.03 2.06.42 2.81 1.17S12.93 6.86 12.93 8s-.37 2.08-1.12 2.83s-1.69 1.12-2.81 1.12s-2.06-.37-2.81-1.12S5.07 9.14 5.07 8s.37-2.08 1.12-2.83S7.88 4.03 9 4m8 18a5 5 0 0 0 5-5a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5m-1-8h1.5v2.82l2.44 1.41l-.75 1.3L16 17.69z"
          }];
        case "tmi-two-hands":
          return [{
            path: "M11 6h3l3.29-3.3a1 1 0 0 1 1.42 0l2.58 2.59a1 1 0 0 1 0 1.41L19 9h-8v2a1 1 0 0 1-1 1a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2m-6 5v4l-2.29 2.29a1 1 0 0 0 0 1.41l2.58 2.59a1 1 0 0 0 1.42 0L11 17h4a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h-7v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z"
          }];
        case "tmi-x":
          return [{
            path: "M173.57 122.15 285.27 0h-26.46l-97.03 110.38L84.34 0H0l117.13 166.93L0 295.25h26.46l102.4-116.59 81.8 116.59h89.34M31.01 14.54H71.66l187.13 262.13h-40.66"
          }];
        case "tmi-google":
          return [{
            path: "M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z"
          }];
        case "tmi-format-quote-close":
          return [{
            path: "M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z"
          }];
        case "tmi-sponsor-up":
          return [{
            path: "M15.366 3.38365V7.01863L18 9.58404L15.366 12.1494V15.7844H11.634L10.205 17.1762V9.03399L12.5352 11.4232L13.9089 9.76993L8.99985 4.8027L4.09076 9.76993L5.46087 11.4232L7.80068 9.03399V17.1817L6.36605 15.7844H2.63395V12.1494L0 9.58404L2.63395 7.01863V3.38365H6.36605L9 0.818237L11.634 3.38365H15.366Z"
          }];
        case "tmi-gauge-match-125":
          return [{
            path: "M12.1421 2.14215C14.7943 2.14215 17.3378 3.19572 19.2132 5.07108C22.805 8.66298 23.0933 14.3075 20.0778 18.2288L19.0174 16.2361C20.8494 13.1645 20.4433 9.12962 17.7989 6.4853C14.6747 3.3611 9.60943 3.3611 6.48524 6.4853C3.36104 9.60949 3.36104 14.6748 6.48524 17.799L5.07102 19.2132C3.19566 17.3379 2.14209 14.7943 2.14209 12.1422C2.14209 9.48999 3.19566 6.94645 5.07102 5.07108C6.94639 3.19572 9.48992 2.14215 12.1421 2.14215ZM9.83474 12.8087C9.71881 11.4836 10.6972 10.3155 12.0199 10.1998C12.9141 10.1216 13.7392 10.541 14.2087 11.2172L19.375 18.5907L11.3396 14.837C10.5222 14.5055 9.91661 13.7445 9.83474 12.8087ZM11.7071 17L11 16.2929L8.29285 19L8.99995 19.7071L11.7071 17ZM14.7071 18L14 17.2929L11.2928 20L12 20.7071L14.7071 18ZM17.7071 19L17 18.2929L14.2928 21L15 21.7071L17.7071 19Z"
          }];
        case "tmi-ai-stars":
          return [{
            path: "M9.273 4.727l2.273 5 5 2.273-5 2.273-2.273 5-2.273-5-5-2.273 5-2.273 2.273-5z",
            color: "#CE93D8"
          }, {
            path: "M18.364 14.727l-1.137 2.5-2.5 1.136 2.5 1.137 1.137 2.5 1.136-2.5 2.5-1.137-2.5-1.136-1.136-2.5z",
            color: "#2196F3"
          }, {
            path: "M18.364 9.273L19.5 6.773l2.5-1.137-2.5-1.136L18.364 2l-1.137 2.5-2.5 1.136 2.5 1.137 1.137 2.5z",
            color: "#CDDC39"
          }];
        default:
          return [{
            path: ""
          }];
      }
    },
    svgStyles() {
      switch (this.icon) {
        case "tmi-ai-stars":
          return "display: inline; opacity: 0; animation: fadeInAndScale 0.8s ease-in-out forwards;";
        default:
          return "";
      }
    },
    viewbox() {
      switch (this.icon) {
        case "tmi-weight-plus":
          return "2 2 19 14";
        case "tmi-x":
          return "0 0 300 300";
        default:
          return "0 0 24 24";
      }
    }
  }
});

const __vue_script__$1 = script$1;
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  _vm._self._c || _h;
  return _vm._m(0);
};
var __vue_staticRenderFns__$1 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    style: _vm.svgStyles,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": _vm.viewbox
    }
  }, _vm._l(_vm.svgObject, function (svg, idx) {
    return _c('path', {
      key: idx,
      attrs: {
        "d": svg.path,
        "fill": svg.color
      }
    });
  }), 0);
}];
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-6ede8155_0", {
    source: "@keyframes fadeInAndScale{from{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__$1 = undefined;
const __vue_module_identifier__$1 = undefined;
const __vue_is_functional_template__$1 = false;
const __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);
var TmiCustomSvg = __vue_component__$1;

var script = Vue.extend({
  name: "tmd-icon",
  components: {
    TmiCustomSvg
  },
  props: {
    size: {
      type: [String, Number],
      default: "24px"
    },
    fill: {
      type: Boolean,
      default: false
    },
    mirror: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customIcon() {
      var _this$$slots$default$, _this$$slots$default;
      const slot = (_this$$slots$default$ = (_this$$slots$default = this.$slots.default) === null || _this$$slots$default === void 0 || (_this$$slots$default = _this$$slots$default.map(slot => slot.text)) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default.join("")) !== null && _this$$slots$default$ !== void 0 ? _this$$slots$default$ : "";
      return slot.trim().startsWith("tmi-") ? slot.trim() : "";
    },
    iconSize() {
      return typeof this.size === "number" ? `${this.size}px` : this.size;
    }
  }
});

const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('i', {
    class: ['tmd-icon material-symbols-outlined', {
      'tmd-icon--filled': _vm.fill,
      'tmd-icon--mirrored': _vm.mirror
    }],
    style: {
      '--tmd-icon-size': _vm.iconSize
    }
  }, [_vm.customIcon ? _c('tmi-custom-svg', {
    attrs: {
      "icon": _vm.customIcon
    }
  }) : _vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-75390d92_0", {
    source: ".tmd-icon[data-v-75390d92]{width:var(--tmd-icon-size,24px);min-width:var(--tmd-icon-size,24px);height:var(--tmd-icon-size,24px);font-size:var(--tmd-icon-size,24px)!important;display:inline-flex;user-select:none;align-items:center;justify-content:center;vertical-align:middle;transition:color .4s cubic-bezier(.4,0,.2,1);direction:ltr;font-feature-settings:\"liga\";font-style:normal;letter-spacing:normal;line-height:1;text-rendering:optimizeLegibility;text-transform:none;word-wrap:normal;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-variation-settings:\"FILL\" 0,\"wght\" 400,\"GRAD\" 0,\"opsz\" 24}.tmd-icon--filled[data-v-75390d92]{font-variation-settings:\"FILL\" 1,\"wght\" 400,\"GRAD\" 0,\"opsz\" 24}.tmd-icon--mirrored[data-v-75390d92]{transform:rotateY(180deg)}.tmd-icon svg[data-v-75390d92]{width:100%;height:100%;fill:currentcolor}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = "data-v-75390d92";
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
